import React, { useState } from 'react';
import LeadForm from './LeadForm';

const catalogues = [
  {
    title: 'Complete Product Catalogue 2026',
    href: '/assets/catalogues/zyvora-product-catalogue.pdf',
    description: 'Complete overview of cattle feed supplement formulations, benefits, and usage recommendations.'
  },
  {
    title: 'Dairy Productivity Solutions',
    href: '/assets/catalogues/zyvora-product-catalogue.pdf',
    description: 'Focused literature for lactation, fertility, digestion, and immunity support products.'
  },
  {
    title: 'Dealer Starter Literature',
    href: '/assets/catalogues/zyvora-product-catalogue.pdf',
    description: 'Premium sales-support document for distributor conversations and farm visits.'
  }
];

function Catalogues() {
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [selectedCatalogue, setSelectedCatalogue] = useState(null);

  const triggerDownload = (catalogue) => {
    const link = document.createElement('a');
    link.href = catalogue.href;
    link.download = catalogue.title;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadClick = (catalogue) => {
    setSelectedCatalogue(catalogue);
    setShowEnquiry(true);
  };

  const handleSuccess = () => {
    if (selectedCatalogue) triggerDownload(selectedCatalogue);
    setShowEnquiry(false);
    setSelectedCatalogue(null);
  };

  return (
    <div className="section catalogue-section light-bg reveal">
      <div className="content catalogue-panel">
        <div className="section-heading-row">
          <div>
            <p className="eyebrow">Catalogue</p>
            <h2>Download premium product literature.</h2>
          </div>
          <p>Access catalogue PDFs after submitting a short lead form, helping Zyvora follow up with product guidance and distributor support.</p>
        </div>
        <div className="cards three-grid">
          {catalogues.map((catalogue) => (
            <article className="card catalogue-card" key={catalogue.title}>
              <span className="catalogue-icon" aria-hidden="true">▤</span>
              <h3>{catalogue.title}</h3>
              <p>{catalogue.description}</p>
              <button type="button" className="btn secondary" onClick={() => handleDownloadClick(catalogue)}>
                Lead Form + Download
              </button>
            </article>
          ))}
        </div>
      </div>

      {showEnquiry && (
        <div className="enquiry-modal-overlay" role="presentation">
          <div className="enquiry-modal" role="dialog" aria-modal="true" aria-labelledby="catalogue-enquiry-title">
            <button type="button" className="modal-close" onClick={() => setShowEnquiry(false)} aria-label="Close catalogue form">×</button>
            <p className="eyebrow">Catalogue Download Form</p>
            <h3 id="catalogue-enquiry-title">Tell us where to send support for {selectedCatalogue?.title}</h3>
            <LeadForm formType={`Catalogue Download - ${selectedCatalogue?.title || 'Catalogue'}`} submitLabel="Submit & Download" compact onSuccess={handleSuccess} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Catalogues;
